/*
 * Getters for the [reporters store]{link module:store/reporters}
 *
 * @module store/reporters/getters
 */

/**
 * Getter to get a List of all Reporters
 *
 * @function
 *
 * @return Array{object} every 'reporter' consists of { id, name, subscribed, type, disabled}
 */
export const emsReportersList = (state) => {
  const list = []
  for (const reporterId in state) {
    list.push({
      id: state[reporterId].id,
      name: state[reporterId].name,
      subscribed: state[reporterId].subscribed,
      type: state[reporterId].type,
      disabled: state[reporterId].disabled
    })
  }

  return list
}

/**
 * Getter for a single reporter
 *
 * @function
 *
 * @return {function} which returns for a `reporterId`: {Reporter}`
 */
export const getReporter = (state) => {
  return (reporterId) => {
    return state?.[reporterId]
  }
}

/**
 * Getter for a single reporter
 *
 * @function
 *
 * @return {function} which returns for a `reporterId`: {Reporter}`
 */
export const getUserSubscription = (state) => {
  return ({ reporterId, userId }) => {
    return state?.[reporterId]?.users?.[userId]
  }
}

/**
 * Getter for the reporters of a user
 *
 * @function
 *
 * @return Array{object} every 'reporter' as {id, ems, emsId, groupId, name, type, disabled}
 */
export const userReportersList = (state, getters, rootState, rootGetters) => {
  const list = []
  for (const reporterId in state) {
    let ems = null
    let emsId = null
    const groupId = state[reporterId].groupId
    const g = rootGetters['energyManagementSystemGroups/getEmsGroup'](groupId)

    if (!g) continue

    if (g?.name === 'Groups::EmsAccessGroup') {
      const e = Object.values(rootGetters['energyManagementSystems/getEmssForGroup'](groupId))?.[0]

      emsId = e.id
      ems = e.name
    } else {
      ems = g?.name
    }

    list.push({
      id: state[reporterId].id,
      ems,
      emsId,
      groupId,
      name: state[reporterId].name,
      type: state[reporterId].type,
      disabled: state[reporterId].disabled
    })
  }

  return list
}
